import React from "react";
import { FaTwitter, FaLinkedin, FaAngellist, FaGithub } from "react-icons/fa";

const Footer = () => {
  const d = new Date();
  const year = d.getFullYear();

  const socials = [
    {
      link:"https://twitter.com/devaladdin",
      name: "Twiter",
      logo: <FaTwitter />
    },
    {
      link:"https://www.linkedin.com/in/inaolaji-taofeek-64587b169",
      name: "Linkedin",
      logo: <FaLinkedin />
    },
    {
      link:"https://angel.co/u/taofeek-akinkunmi",
      name: "Wellfound",
      logo: <FaAngellist />
    },
    {
      link:"https://github.com/aladdin4u",
      name: "Github",
      logo: <FaGithub />
    },
  ]

  return (
    <div className="py-[64px] flex flex-col justify-center items-center px-6">
      <div className="flex space-x-1 my-4">
        {socials &&
          socials.map((social) => (
            <a
              href={social.link}
              key={social.link}
              target="_blank"
              aria-label={social.name}
              rel="noopener"
              className="text-zinc-400 hover:bg-zinc-800 hover:text-zinc-300 px-3 py-2 rounded-md text-sm font-medium"
            >
              {social.logo}
            </a>
          ))}
      </div>
      <p className="font-sm">
        &copy; Powered by Aladdin Consultant{" "}
        <span className="font-medium">{year}</span>
      </p>
    </div>
  );
};

export default Footer;
